import { DepartmentContent } from "../../components/configuration";

export default function Department() {
  return (
    <>
      <DepartmentContent />
    </>
  );
}
